import { useCurrentStream } from '../../feature-player/hooks/player-instance/use-current-stream';

import { usePromoOtt } from './use-promo-ott';

export const usePromoCurrentStream = (contentId: string) => {
    const promoOtt = usePromoOtt(contentId);

    return useCurrentStream(promoOtt?.streams);
};
